import { OfferLettersTable } from './tables/offer-letters/offer-letters-index.table';
import { OfferLettersService } from './offer-letters.service';

const Services = [OfferLettersTable, OfferLettersService];

export { Services, OfferLettersTable, OfferLettersService };
